import React from 'react';
import withBrand from './withBrand';
import { findKeyInObj } from 'app/utils/objects';
import PropTypes from 'prop-types';

function BrandToggleBoolean({ children, brand, configKey }) {
  const configVal = findKeyInObj(brand, configKey);
  if (configVal) {
    return children[0];
  }
  return children[1];
}

BrandToggleBoolean.propTypes = {
  brand: PropTypes.object.isRequired,
  configKey: PropTypes.string.isRequired,
  children: (props, propName) => {
    const arr = React.Children.toArray(props[propName]);
    if (arr.length !== 2) {
      return new Error('Invalid children. Exactly two must be provided');
    }
  },
};

export default withBrand(BrandToggleBoolean);



// WEBPACK FOOTER //
// ./src/app/ui/config/BrandToggleBoolean.js